'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:HolydaysNewCtrl
 * @description
 * # HolydaysNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('HolydaysNewCtrl', [
    '$scope', 'Holyday', 'FileSaver', 'toaster', '$state', function ($scope, Holyday, FileSaver, toaster, $state) {

    $scope.filename = 'Archivo';
    const data = new FormData();

    $scope.downloadHolydaysFormat = () => {
      return Holyday.downloadHolydaysFormat().then((response) => {
        var blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        FileSaver.saveAs(blob, 'Formato_dias_festivos.csv');
        toaster.pop('success', 'Dias festivos', 'Se descargo el csv de los dias festivos');
      }).catch(error => {
        console.error(error);
        toaster.pop('error', 'Dias festivos', error.data.error);
      });
    }

    $scope.importHolydays = () => {
      if (data.values().next().value != undefined && data.values().next().value.type == 'text/csv') {
        if(window.confirm('¿Estas seguro que deseas importar estas fechas para días destivos?')){
          Holyday.importHolydays(data).then((response) => {
            if (response.data.hasOwnProperty("invalid_dates")) {
              toaster.pop('error', 'Dias festivos', `No se importo ningún día festivo. ${response.data.invalid_dates}`);
              $('#file')[0].value = ''
            } else if(response.data.imported_dates == 0){
              toaster.pop('warning', 'Dias festivos', `Todas las fechas ya estan registradas como día festivo`);
              $('#file')[0].value = ''
            }else if(response.data.imported_dates > 0){
              toaster.pop('success', 'Dias festivos', `Se importaron correctamente todas las fechas como día festivo`);
              $state.go('app.holydays.list');
            }
          }).catch(error => {
            if (error.data.exception == '#<ArgumentError: invalid date>') {
              toaster.pop('error', 'Dias festivos', 'Fecha invalida en el archivo.');
            } else {
              toaster.pop('error', 'Dias festivos', "Las siguientes fechas del archivo tienen formato incorrecto: " + error.data.errors);
            }
              $('#file')[0].value = ''
          });
        }
      } else {
        toaster.pop('error', 'Dias festivos', 'Archivo no valido o no seleccionado.');
      }
    }

    $("#file").change(function() {
      $scope.filename = this.files[0].name;
      data.delete("file");
      data.append( 'file', this.files[0], this.files[0].name);
    });

  }]);
